/* EVENTS INVOLVING CIWP (Collaborative Inquiry and Wellness Planning) */

export default {
  ciwp_link_shared: {
    // User clicks "Copy to Clipboard" button to share the CIWP link
    excludeSuperAdmin: false,
    getProps: ({ ciwpId, shareSlug, publicUrl }) => ({
      ciwpId,
      shareSlug,
      publicUrl,
    }),
  },
};
